export { default as CommentaryRenderer } from './component';
